import { Button, DialogContent, Divider } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { ModalComponent } from 'app/shared-components/modals/modalManager';
import { useNavigate } from 'react-router-dom';

export const NorthOfferCompletedMessageDialog: ModalComponent = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    onClose();
    navigate('/merchant/offers');
  };

  return (
    <AppSimpleDialog
      open={open}
      handleClose={onClose}
      title="Thank you!"
      size="sm"
      scroll="paper"
      disableScrollLock
    >
      <Divider />
      <DialogContent className="px-24 flex flex-col">
        <p className="mb-24">
          Thank you for accepting the offer! The payment processor was notified and will contact you
          shortly to complete the next steps.
        </p>
        <Button
          className="rounded-full bg-blue-primary px-14 hover:bg-blue-primary-hover text-white"
          onClick={handleRedirect}
        >
          Back to Offers
        </Button>
      </DialogContent>
    </AppSimpleDialog>
  );
};
